import React from "react";
import PageLayout from "./PageLayout";
import PageHero from "./PageHero";
import VideoEmbed from "./VideoEmbed";
import FadeIn from "./FadeIn";

/** Video + story layout for engagement pages */
const EngagementVideoPage = ({ title, videoUrl, videoTitle, children }) => (
  <PageLayout>
    <PageHero title={title} light />
    <section className="ku-section bg-white">
      <div className="ku-container max-w-4xl">
        <FadeIn>
          <VideoEmbed src={videoUrl} title={videoTitle || title} />
        </FadeIn>
        <FadeIn delay={0.15}>
          <div className="ku-prose mt-10">{children}</div>
        </FadeIn>
      </div>
    </section>
  </PageLayout>
);

export default EngagementVideoPage;
